/**
 * Injects a user’s raw CSS into the page,
 * forcing it(!important) to override existing styles.
 * Handles @import/@font-face at-rules at top.
 */
export function applyCustomCss(cssRules = '') {
  // remove old <style>
  const old = document.getElementById('company-custom-css');
  if (old) old.remove();
  if (!cssRules.trim()) return;

  // separate any @import/@font-face lines
  const lines   = cssRules.split('\n');
  const atRules = lines.filter(l => {
    const t = l.trim();
    return t.startsWith('@import') || t.startsWith('@font-face');
  });
  const restCss = lines.filter(l => !atRules.includes(l)).join('\n');

  // map any body{} declarations onto html,body,#root,.app-container,.content
  const bodyMatch = restCss.match(/body\s*\{([^}]*)\}/);
  let mappingRule = '';
  if (bodyMatch) {
    const decls = bodyMatch[1]
      .split(';')
      .map(s => s.trim()).filter(Boolean)
      .map(d => d.includes('!important') ? d : `${d} !important`)
      .join('; ');
    mappingRule = `html, body, #root, .app-container, .content { ${decls} }`;
  }

  // force every other rule to !important
  const forced = restCss
    .split('}')
    .map(rule => {
      const [selector, decls] = rule.split('{');
      if (!decls) return '';
      const importantDecls = decls
        .split(';')
        .map(s => s.trim()).filter(Boolean)
        .map(d => d.includes('!important') ? d : `${d} !important`)
        .join('; ');
      return `${selector}{${importantDecls}}`;
    })
    .join(' ');

  // re-assemble
  const style = document.createElement('style');
  style.id = 'company-custom-css';
  style.textContent = [
    ...atRules,
    mappingRule,
    forced
  ].filter(Boolean).join('\n');

  document.head.appendChild(style);
}
